module.exports = __webpack_public_path__ + "img/practice-3.dea27be0.jpg";